const deliveryConfirmationDE = {
    "view": {
        "table": {
            "title": "Gelieferte Liste",
            "columns": {
                "release": "Veröffentlichung",
                "upc": "UPC-Nummer",
                "action": "Aktion",
                "status": "Status",
                "deliveryDate": "Lieferdatum",
                "details": "Details"
            },
            "label": {
                "statusDelivered": "GELIEFERT",
                "statusPartially": "TEILWEISE",
                "statusUndelivered": "NICHT GELIEFERT",
                "ddexActionInsert": "EINFÜGEN",
                "ddexActionFullUpdate": "VOLLES UPDATE",
                "ddexActionMetadataUpdate": "META. UPDATE",
                "ddexActionTakedown": "ENTFERNEN"
            },
            "placeholder": {
                "search": "Suche..."
            },
            "button": {
                "open": "ÖFFNEN",
                "exportCSV": "CSV exportieren"
            }
        }
    },
    "breakdownView": {
        "table": {
            "title": "Store-Lieferliste",
            "column": {
                "store": "Store",
                "additionalNote": "Zusätzliche Notizen",
                "status": "Status"
            },
            "label": {
                "statusDelivered": "GELIEFERT",
                "statusUndelivered": "NICHT GELIEFERT"
            },
            "button": {
                "exportCSV": "CSV exportieren"
            },
            "message": {
                "appleSubjectToQC": "Erfolgreich geliefert, unterliegt zusätzlicher QC-Kontrolle durch Apple Music-Mitarbeiter.",
                "releaseDeliverySuccessfull": "Veröffentlichung wurde erfolgreich an die {{dspName}}-Server geliefert",
                "releaseDeliveryUnsuccessfull": "Veröffentlichungslieferung war für {dspName} nicht erfolgreich.",
                "noDeliveriesPossible": "Derzeit sind keine Lieferungen möglich"
            }
        }
    }
};

export default deliveryConfirmationDE;